var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.608a2.188 2.188 0 0 1-1.366 1.317 18.519 18.519 0 0 1-3.034.725c-.15.025-.3.042-.45.059-.183.024-.375.041-.566.058-.525.042-1.042.067-1.567.067-.533 0-1.067-.025-1.592-.075a8.395 8.395 0 0 1-.658-.075l-.367-.05c-.091-.017-.183-.026-.275-.042a17.23 17.23 0 0 1-2.733-.675c-.667-.225-1.175-.7-1.4-1.309-.225-.6-.142-1.3.217-1.9l.941-1.566c.2-.342.384-1 .384-1.4v-1.55a5.488 5.488 0 0 1 5.483-5.484c3.017 0 5.475 2.459 5.475 5.484v1.55c0 .4.183 1.058.392 1.4l.941 1.567a2.21 2.21 0 0 1 .175 1.9z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.967a.633.633 0 0 1-.634-.634V5.75a.633.633 0 1 1 1.267 0v2.583a.644.644 0 0 1-.633.634zM12.359 16.675A2.512 2.512 0 0 1 10 18.333a2.471 2.471 0 0 1-1.766-.741 2.3 2.3 0 0 1-.584-.925c.109.016.217.025.334.041.191.025.391.05.591.067.475.042.959.067 1.442.067.475 0 .95-.025 1.417-.067.175-.017.35-.025.516-.05l.409-.05z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBing);
export default __webpack_public_path__ + "static/media/notification-bing.0f4ef5ffb32ffd4c1498cb4976ffe2d9.svg";
export { ForwardRef as ReactComponent };